import React from 'react';
import { motion } from 'framer-motion';

const PrivacyPolicy = () => {
  return (
    <div className="bg-brand-light min-h-screen py-20 px-4">
      <div className="max-w-3xl mx-auto bg-white p-8 md:p-12 rounded-3xl shadow-sm border border-gray-100">
        <motion.h1 
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-3xl font-serif font-bold text-brand-dark mb-8 border-b pb-4"
        >
          Privacy Policy
        </motion.h1>
        
        <div className="prose prose-brand text-gray-700 space-y-6">
          <p className="text-sm text-gray-500 italic">Last Updated: {new Date().toLocaleDateString()}</p>
          
          <section>
            <h2 className="text-xl font-bold text-brand-green mb-2">1. Overview</h2>
            <p>Golden Compass Travel Guides is owned and operated by <strong>WinWhen Consulting Corp.</strong> We value your privacy and are committed to protecting any personal information you share with us.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-brand-green mb-2">2. Information We Collect</h2>
            <p>We may collect basic information such as your name and email address if you voluntarily sign up for newsletters or contact us. We also use standard analytics to understand how visitors interact with our site.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-brand-green mb-2">3. How We Use Information</h2>
            <p>Your information is used solely to provide travel guidance, respond to inquiries, and improve our services. We do not sell or rent your personal data to third parties.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-brand-green mb-2">4. Contact Us</h2>
            <p>If you have questions about this policy, please contact us through the links provided on our main page.</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;